import { formatFromUnderscoreToHumanReadable } from "@/src/lib/string";
import { adminDocumentTypeDisplay } from "@/src/models/documents/admin/admin";
import { blankTypeDisplay } from "@/src/models/documents/blank";
import { carePlanTypeDisplay } from "@/src/models/documents/care-plan";
import { clearanceRequestTypeDisplay } from "@/src/models/documents/clearance-request/clearance-request";
import { consentTypeDisplay } from "@/src/models/documents/consent";
import { coverPageTypeDisplay } from "@/src/models/documents/cover-page";
import { dmeTypeDisplay } from "@/src/models/documents/dme/dme";
import { financialTypeDisplay } from "@/src/models/documents/financial/finanical";
import { identificationCardTypeDisplay } from "@/src/models/documents/identification-card/identification-card";
import { imagingResultsTypeDisplay } from "@/src/models/documents/imaging/imaging-results";
import { incompleteDisplayType } from "@/src/models/documents/incomplete/incomplete";
import { informationRequestTypeDisplay } from "@/src/models/documents/information-request";
import { insuranceCardTypeDisplay } from "@/src/models/documents/insurance-card/insurance-card";
import { intakeTypeDisplay } from "@/src/models/documents/intake/intake";
import { junkTypeDisplay } from "@/src/models/documents/junk";
import { labResultsTypeDisplay } from "@/src/models/documents/lab-results/lab-results";
import { legalTypeDisplay } from "@/src/models/documents/legal/legal";
import { medicalHistoryTypeDisplay } from "@/src/models/documents/medical-history/medical-history";
import { medicalRecordRequestTypeDisplay } from "@/src/models/documents/medical-records-request/medical-record-request";
import { notificationTypeDisplay } from "@/src/models/documents/notification/notificaiton";
import { orderTypeDisplay } from "@/src/models/documents/order";
import { otherTypeDisplay } from "@/src/models/documents/other";
import { pharmacyRelatedTypeDisplay } from "@/src/models/documents/pharmacy-related/pharmacy-related";
import { priorAuthorizationTypeDisplay } from "@/src/models/documents/prior-authorization/prior-authorization";
import { procedureTypeDisplay } from "@/src/models/documents/procedure/procedure";
import { progressNoteTypeDisplay } from "@/src/models/documents/progress-note/progress-note";
import { referralTypeDisplay } from "@/src/models/documents/referral";
import { referralStatusRequestTypeDisplay } from "@/src/models/documents/referral-status-request";
import { referrerInformationTypeDisplay } from "@/src/models/documents/referrer-information";
import { responseToVhRequestTypeDisplay } from "@/src/models/documents/resonse-to-vh-request";
import { unknownTypeDisplay } from "@/src/models/documents/unknown";

const categoryDisplayNames: { subtypes: Record<string, string>; categoryLabel: string }[] = [
  { subtypes: adminDocumentTypeDisplay, categoryLabel: "Admin" },
  { subtypes: blankTypeDisplay, categoryLabel: "Blank" },
  { subtypes: carePlanTypeDisplay, categoryLabel: "Care Plan" },
  { subtypes: clearanceRequestTypeDisplay, categoryLabel: "Clearance Request" },
  { subtypes: consentTypeDisplay, categoryLabel: "Consent" },
  { subtypes: coverPageTypeDisplay, categoryLabel: "Cover Page" },
  { subtypes: dmeTypeDisplay, categoryLabel: "DME" },
  { subtypes: financialTypeDisplay, categoryLabel: "Financial" },
  { subtypes: identificationCardTypeDisplay, categoryLabel: "Identification Card" },
  { subtypes: imagingResultsTypeDisplay, categoryLabel: "Imaging Results" },
  { subtypes: incompleteDisplayType, categoryLabel: "Incomplete" },
  { subtypes: informationRequestTypeDisplay, categoryLabel: "Information Request" },
  { subtypes: insuranceCardTypeDisplay, categoryLabel: "Insurance Card" },
  { subtypes: intakeTypeDisplay, categoryLabel: "Intake" },
  { subtypes: junkTypeDisplay, categoryLabel: "Junk" },
  { subtypes: labResultsTypeDisplay, categoryLabel: "Lab Results" },
  { subtypes: legalTypeDisplay, categoryLabel: "Legal" },
  { subtypes: medicalHistoryTypeDisplay, categoryLabel: "Medical History" },
  { subtypes: medicalRecordRequestTypeDisplay, categoryLabel: "Medical Record Request" },
  { subtypes: notificationTypeDisplay, categoryLabel: "Notification" },
  { subtypes: orderTypeDisplay, categoryLabel: "Order" },
  { subtypes: otherTypeDisplay, categoryLabel: "Other" },
  { subtypes: pharmacyRelatedTypeDisplay, categoryLabel: "Pharmacy Related" },
  { subtypes: priorAuthorizationTypeDisplay, categoryLabel: "Prior Auth" },
  { subtypes: procedureTypeDisplay, categoryLabel: "Procedure" },
  { subtypes: progressNoteTypeDisplay, categoryLabel: "Progress Note" },
  { subtypes: referralTypeDisplay, categoryLabel: "Referral" },
  { subtypes: referralStatusRequestTypeDisplay, categoryLabel: "Referral Status Request" },
  { subtypes: referrerInformationTypeDisplay, categoryLabel: "Referrer Information" },
  { subtypes: responseToVhRequestTypeDisplay, categoryLabel: "Response to VH Request" },
  { subtypes: unknownTypeDisplay, categoryLabel: "Unknown" },
];

export function isCanonicalClassificationSlug(value: string): boolean {
  return /^[a-z][a-z0-9_]*$/.test(value);
}

export function getClassificationDisplay(classification: string, withPrefix: boolean = false): string {
  for (const { subtypes, categoryLabel } of categoryDisplayNames) {
    const displayName = subtypes[classification];

    if (!displayName) continue;
    else if (withPrefix && displayName !== categoryLabel) return `${categoryLabel} - ${displayName}`;
    else return displayName;
  }

  return formatFromUnderscoreToHumanReadable(classification);
}
